<template>
  <div id="notifications">
    <div class="contents">
      <div class="column for-membership">
        <ul v-if="notificationList.length > 0">
          <li
            v-for="(item, index) in notificationList"
            :key="index"
            @click="clickAlarms(item.alertSeqId, item.type)"
          >
            <div
              class="photo"
              :style="{
                backgroundImage: `url(data:image/png;base64,${item.profileImage})`
              }"
            ></div>
            <div class="txt">{{ item.alertContent }}</div>
          </li>
        </ul>
        <ul v-else>
          No new notifications.
        </ul>
      </div>
    </div>

    <comp-loading v-if="isLoading" :fullscreen="true"></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common'
import NotificationService from '@/services/notification-service'
import CompLoading from '@/components/CompLoading.vue'

export default {
  name: 'Notifications',
  mixins: [common],
  components: { CompLoading },
  data() {
    return {
      isLoading: false,

      notificationList: []
    }
  },
  created() {
    this.$parent.setNav(true)
    this.$parent.setHeader('Notifications')
    this.$parent.headerBack = true
    this.$parent.setBottomTab(false)

    this.getNotification()
  },
  computed: {
    isAvailableAccessRoomAndConn() {
      return this.$store.state.auth.isUserPermitAll
    }
  },
  methods: {
    getNotification() {
      this.isLoading = true

      NotificationService.getNotifications().then(
        ({ resultCode, resultData }) => {
          this.isLoading = false

          if (resultCode === 0) {
            this.notificationList = resultData.list
          }
        }
      )
    },
    clickAlarms(seqId, type) {
      this.isLoading = true

      if (this.isAvailableAccessRoomAndConn) {
        if (type === 'room_invite') {
          this.goPageWithParams('Rooms', { listType: 'roomReceived' })
        } else if (type === 'connection_invite') {
          this.goPageWithParams('Connections', { listType: 'received' })
        }
        NotificationService.deleteAlarms(seqId).then(({ resultCode }) => {
          this.isLoading = false

          if (resultCode === 0) {
            this.getNotification()
          }
        })
      } else {
        this.isLoading = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="@/scss/notifications.scss" scoped></style>
